import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { Helmet } from "react-helmet";
import Navbar from "./components/Navbar";
import Mainpage from "./components/Mainpage";
import Product from "./components/Product";
import ContactUs from "./components/ContactUs";
import Partnerships from "./components/Partnerships";
import Pricing from "./components/Pricing";
import About from "./components/About";
import Footer from "./components/Footer";
import TermsandConditions from "./Text-Files/TermsandConditions";
import PrivacyPolicy from "./Text-Files/PrivacyPolicy";
import Disclosure from "./Text-Files/Disclosure";
import PoliciesAndProcedures from "./Text-Files/PoliciesAndProcedures";
import InvestorCharter from "./Text-Files/InvestorCharter";
import InvestorComplaints from "./Text-Files/InvestorComplaints";
import ReactGA from "react-ga4";
import AccountClosure from "./Text-Files/AccountClosure";
import Insurance from "./components/Insurance";
import KRA from "./components/KRA";
import TaxFiling from "./components/TaxFiling";
import clevertap from "clevertap-web-sdk";
import NotFound from "./components/NotFound";

function App() {
  let CLEVER_TAP_KEY = process.env.REACT_APP_CLEVER_TAP_KEY;

  useEffect(() => {
    ReactGA.initialize("G-QP5NR9NGYY");
    clevertap.privacy.push({ optOut: false });
    clevertap.privacy.push({ useIP: false });
    clevertap.init(CLEVER_TAP_KEY);
    clevertap.spa = true;
  }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Mainpage />} />
        <Route path="/product" element={<Product />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Partnerships" element={<Partnerships />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/About" element={<About />} />
        <Route path="/TermsandConditions" element={<TermsandConditions />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/Disclosure" element={<Disclosure />} />
        <Route path="/Insurance" element={<Insurance />} />

        <Route
          path="/PoliciesAndProcedures"
          element={<PoliciesAndProcedures />}
        />
        <Route path="/InvestorCharter" element={<InvestorCharter />} />
        <Route path="/AccountClosure" element={<AccountClosure />} />
        <Route path="/InvestorComplaints" element={<InvestorComplaints />} />
        <Route path="/KRA" element={<KRA />} />
        <Route path="/TaxFiling" element={<TaxFiling />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
